import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { opsRouteRef, rootRouteRef } from './routes';

export const releaseConductorPlugin = createPlugin({
  id: 'release-conductor',
  routes: {
    root: rootRouteRef,
    ops: opsRouteRef,
  },
});

export const ReleaseWizardPage = releaseConductorPlugin.provide(
  createRoutableExtension({
    name: 'ReleaseWizardPage',
    component: () =>
      import('./components/ReleaseWizardPage').then(m => m.ReleaseWizardPage),
    mountPoint: rootRouteRef,
  }),
);

export const ReleaseOpsPage = releaseConductorPlugin.provide(
  createRoutableExtension({
    name: 'ReleaseOpsPage',
    component: () => import('./components/ReleaseOpsPage').then(m => m.ReleaseOpsPage),
    mountPoint: opsRouteRef,
  }),
);
